/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { createRef, Component } from 'react';
import PropTypes from 'prop-types';
import { uniqueId } from 'lodash';

import { withTranslation } from 'react-i18next';

// material ui
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import { Hidden } from '@material-ui/core';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';
import FormatListBulletedIcon from '@material-ui/icons/FormatListBulleted';
import Box from '@material-ui/core/Box';
import Paper from '@material-ui/core/Paper';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import FullscreenControl from 'react-leaflet-fullscreen';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import MenuIcon from '@material-ui/icons/Menu';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import { RainIcon } from '../../../assets/svg/Icon';
import formatNumber from '../../../utils/number/Number';
// import Radio from '@material-ui/core/Radio';
// import RadioGroup from '@material-ui/core/RadioGroup';
// import FormControlLabel from '@material-ui/core/FormControlLabel';
// import FormControl from '@material-ui/core/FormControl';
// import FormLabel from '@material-ui/core/FormLabel';

// map
import L from 'leaflet';
import {
  Map, Marker, TileLayer, GeoJSON, LayerGroup, LayersControl, Tooltip, Popup, WMSTileLayer,
} from 'react-leaflet';
import Control from 'react-leaflet-control';
// import 'leaflet-kmz';
// import zipObject from 'lodash/zipObject';

// screen width
import withWidth, { isWidthDown, isWidthUp } from '@material-ui/core/withWidth';
import { compose } from 'recompose';
import { styles } from './Style';
import FlashFloodChart from './FlashFloodChart';
import FlashFloodList from './FlashFloodList';
import LegendFcstRain from './LegendFcstRain';
import LegendFFPI from'./LegendFFPI';
import LegendRisk from './LegendRisk';
import LegendObsRain from './LegendObsRain';
import LegendRainfall from './LegendRainfall';
import LegendObsRain5day from './LegendObsRain5day';

// wrf wrf
import { PlottyGeotiffLayer, FFPIGeotiffLayer } from './GeotiffLayer';
import 'plotty';
import 'leaflet-geotiff';
import './LeafletGeotiffPlotty';

import { StormTwcLayer } from './StormTwcLayer';

// icon
import { HiiRainIcon } from '../../../utils/Icon';
import { FaChartLine } from '../../../utils/Fontawesome';

// css
import 'leaflet/dist/leaflet.css';
import 'leaflet-gesture-handling/dist/leaflet-gesture-handling.css';

import RainfallStatusColor from '../../rainfall/map/RinfallStatusColor';

import tJson from '../../../utils/TJson';
import CurrentLocation from '../../currentlocation/CurrentLocation';

const initPath = process.env.REACT_APP_THAIWATER_URL;
const initPathWMS = process.env.REACT_APP_FEWS_URL;
const initPathWMS3 = process.env.REACT_APP_WMS3;
const initPathWMS1 = process.env.REACT_APP_WMS;
const jawgToken = process.env.REACT_APP_JAWG_TOKEN;

const { BaseLayer, Overlay } = LayersControl;

const banner = `${initPath}images/models/banner-ffpi.png`;

const fcstRainOptions = {
  name: 'WRF',
  band: 0,
  opacity: 0.7, // not work
  displayMin: 1,
  displayMax: 500,
  colorScale: 'fcstRaincolorscale',
  clampLow: false,
  clampHigh: true,
};

const obsRainOptions = {
  name: 'WRF',
  band: 0,
  opacity: 0.8, // not work
  displayMin: 50,
  displayMax: 500,
  colorScale: 'obsRaincolorscale',
  clampLow: false,
  clampHigh: true,
};

const ffpiOptions = {
  name: 'FFPI',
  band: 0,
  opacity: 0.7,
  displayMin: 0,
  displayMax: 5,
  colorScale: 'ffpiColorscale',   // สเกลสีแดง→เหลือง→เขียว (plotty built-in)
  clampLow: false,
  clampHigh: true,
};

const RAINFALL_LEGEND_TITLE = {
  rainfallToday: 'เกณฑ์ฝนตรวจวัดวันนี้ (มม.)',
  rainfallYesterday: 'เกณฑ์ฝนตรวจวัดวานนี้ (มม.)',
  rainfall24h: 'เกณฑ์ฝนตรวจวัด 24 ชม. (มม.)',
  rainfall3day: 'เกณฑ์ฝนตรวจวัด 3 วัน (มม.)',
  rainfall7day: 'เกณฑ์ฝนตรวจวัด 7 วัน (มม.)',
  rainfall15day: 'เกณฑ์ฝนตรวจวัด 15 วัน (มม.)',
  rainfall30day: 'เกณฑ์ฝนตรวจวัด 30 วัน (มม.)',
};

class FlashFloodMap extends Component {
  _mounted = false;

  constructor(props) {
    super(props);

    this.map = null;
    this.refMap = createRef();
    this.refBoundaryProvince = createRef();
    this.refBoundaryBasin = createRef();
    this.layer = createRef();
    this.layer1 = createRef();
    this.layer3 = createRef();
    this.refGeotiff1 = createRef();
    this.refGeotiff2 = createRef();
    this.refStrom = createRef();
    this.refFfpi = createRef();
    this.refFfpi = createRef();
    this.refObsRain = createRef();

    this.state = {
      error: '',
      // geojsonRiver: [],
      geojsonTambon: [],
      openLegendRisk: false,
      openLegendFcstRain: false,
      openLegendObsRain: false,
      openLegendRainfall: false,
      openLegendFFPI:false,
      showInfo: false,
      // hover: false,
      // tifValue: 'fcst_rain.tif',
      // currentMap: false,
      isBoxVisible: true,
      initActive: false,
      isBoxDetail: true,
      openBoxDetail: true,
    };

    this.getGeoJson = this.getGeoJson.bind(this);
    this.getBasinStyle = this.getBasinStyle.bind(this);
    this.highlightFeature = this.highlightFeature.bind(this);
    this.resetHighlight = this.resetHighlight.bind(this);
    this.handleMouseOut = this.handleMouseOut.bind(this);
    this.bindMarker = this.bindMarker.bind(this);
    this.handleBoxToggle = this.handleBoxToggle.bind(this);
    this.handleMouseOut = this.handleMouseOut.bind(this);
  }

  componentDidMount() {
    const { handleSetMap, width } = this.props;
    this.getGeoJson();
    this._mounted = true;
    document.getElementsByClassName('leaflet-top leaflet-left')[0].style.top = '1%';
    // document.getElementsByClassName('leaflet-overlay-pane')[0].style.opacity = 0.5;
    document.getElementsByClassName('leaflet-top leaflet-right')[0].style.top = '1%';

    this.map = this.refMap.current.leafletElement;
    handleSetMap(this.map);
  }

  componentWillUnmount() {
    this._mounted = false;
  }

  onEachRiskAreaFeature = (feature, layer) => {
    const { datasRiskArea, t } = this.props;
    let popupContent = '';

    datasRiskArea.map(data => {
      // console.log(layer.feature.properties.TAMBON_IDN, ' | ',  data.tambon_id);
      // console.log('data : ', data);
      if (layer.feature.properties.TAMBON_IDN === data.tambon_id) {
        popupContent = `
          ${layer.feature.properties.TAM_NAM_T} <br/>
          ${layer.feature.properties.AMPHOE_T} <br/>
          ${layer.feature.properties.PROV_NAM_T} <br/>
          ${t('ปริมาณฝนล่วงหน้า 24 ชม.')} : <b>${data.accrf} มม.</b>
          ${t('ฝนสะสม 5 วัน')} : <b>${data.rfhistoric} มม.</b>
        `;
        layer.bindTooltip(popupContent);
      }
      // eslint-disable-next-line no-useless-return
      return;
    });
  }

  onEachRiskAreaFeatureNhc = (feature, layer) => {
    const { datasRiskAreaNhc, datasNhc, t } = this.props;

    datasRiskAreaNhc.forEach((data, index) => {
      if (layer.feature.properties.TAMBON_IDN === data.tambon_id) {
        const detail = datasNhc[index];

        // Tooltip เดิม ไม่แตะ
        const popupContent = `
          ${layer.feature.properties.TAM_NAM_T} <br/>
          ${layer.feature.properties.AMPHOE_T} <br/>
          ${layer.feature.properties.PROV_NAM_T} <br/>
          ${t('ปริมาณฝนล่วงหน้า 24 ชม.')} : <b>${data.accrf} มม.</b> <br/>
          ${t('ฝนสะสม 5 วัน')} : <b>${data.rfhistoric} มม.</b>
        `;
        layer.bindTooltip(popupContent);

        const popupClickContent = `
          <style>
            .ffpi-popup, .ffpi-popup * {
              font-family: 'Kanit', sans-serif !important;
            }

            .ffpi-popup .leaflet-popup-close-button {
              width: 25px !important;
              height: 25px !important;
              padding: 10px !important;
              margin: 15px !important;
              border-radius: 999px !important;
              background-color: #EDF3F6 !important;
              color: #627689 !important;
              display: flex !important;
              align-items: center !important;
              justify-content: center !important;
              box-sizing: content-box !important;
              line-height: 1 !important;
              font-size: 21px !important;
              font-weight: 700 !important;
              text-decoration: none !important;
            }
          </style>
          <div class="ffpi-popup" style="
            width: 550px;
            height: 350px;
            border-radius: 18px;
            padding: 14px 16px 12px;
            background-color: #FFFFFF;
            box-sizing: border-box;
            font-family: 'Kanit', sans-serif !important;
            color: #13263A;
          ">
            <div style="
              display: flex;
              justify-content: space-between;
              align-items: flex-start;
              margin-bottom: 10px;
            ">
              <div style="
                display: flex;
                align-items: center;
                gap: 12px;
                min-width: 0;
                flex: 1;
                padding-right: 12px;
              ">
                <div style="
                  width: 46px;
                  height: 46px;
                  border-radius: 12px;
                  background-color: #ff0000;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  flex-shrink: 0;
                ">
                  <span style="color: #FFFFFF; font-size: 30px; line-height: 1; font-weight: 700;">!</span>
                </div>

                <div style="min-width: 0;">
                  <div style="
                    font-weight: 700;
                    font-size: 14px;
                    line-height: 1;
                    color: #ff0000;
                    margin-bottom: 6px;
                  ">
                    ระดับสูง
                  </div>
                  <div style="
                    font-weight: 700;
                    font-size: 22px;
                    color: #13263A;
                    margin-bottom: 6px;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                  ">
                    ตำบล${detail?.tumbon ?? layer.feature.properties.TAM_NAM_T}
                  </div>
                  <div style="
                    font-size: 16px;
                    line-height: 1.1;
                    font-weight: 400;
                    color: #5E7284;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                  ">
                    อ.${detail?.amphon ?? layer.feature.properties.AMPHOE_T} จ.${detail?.provices ?? layer.feature.properties.PROV_NAM_T}
                  </div>
                </div>
              </div>


            </div>

            <div style="
              border-radius: 16px;
              border: 1px solid #D9E5EE;
              margin-top: 15px;
              margin-bottom: 10px;
              padding: 0;
              box-sizing: border-box;
              overflow: hidden;
            ">
              <div style="display: flex;">
                <div style="
                  width: 33.33%;
                  padding: 18px 14px 24px;
                  box-sizing: border-box;
                  border-right: 1px solid #D9E5EE;
                ">
                  <div style="font-size: 16px; color: #7E8F9F; margin-bottom: 4px;">FFPI</div>
                  <div style="font-size: 32px; font-weight: 600; line-height: 1; margin-bottom: 4px; color: #E80A05;">${data.ffpi ?? '-'}</div>
                  <div style="font-size: 14px; color: #8091A2; line-height: 1.08;">ดัชนีความเสี่ยง <span style="color:#E80A05;font-size:14px;font-weight:700;">วิกฤต</span></div>
                </div>

                <div style="
                  width: 33.33%;
                  padding: 18px 14px 24px;
                  box-sizing: border-box;
                  border-right: 1px solid #D9E5EE;
                ">
                  <div style="font-size: 16px; color: #7E8F9F; margin-bottom: 4px;">
                    ฝนสะสม 5 วัน
                  </div>

                  <div style="
                    font-size: 32px;
                    font-weight: 600;
                    line-height: 1;
                    margin-bottom: 4px;
                  ">
                    ${data.rfhistoric ?? '-'} มม.
                  </div>

                  <div style="font-size: 14px; color: #8091A2; line-height: 1.08;">
                    ย้อนหลัง
                  </div>
                </div>

                <div style="
                  width: 33.33%;
                  padding: 18px 14px 24px;
                  box-sizing: border-box;
                ">
                  <div style="font-size: 16px; color: #7E8F9F; margin-bottom: 4px;">ฝนคาดการณ์</div>
                  <div style="font-size: 32px; font-weight: 600; line-height: 1; margin-bottom: 4px; white-space: nowrap;">${data.accrf ?? '-'} มม.</div>
                  <div style="font-size: 14px; color: #8091A2; line-height: 1.08;">24 ชั่วโมง</div>
                </div>
              </div>
            </div>

            <div style="padding: 2px 2px 0; margin-top: 20px;">

              <div
                style="
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                  font-size: 14px;
                  color: #7A8D9E;
                  padding-top: 6px;
                  padding-bottom: 6px;
                  border-bottom: 1px dashed #E1E9EE;
                "
              >
                <span>${t('ลุ่มน้ำ')}</span>
                <span style="font-size: 14px; font-weight: 600; color: #1D3145;">
                  ${detail?.basin ?? '-'}
                </span>
              </div>

              <div
                style="
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                  font-size: 14px;
                  color: #7A8D9E;
                  padding-top: 6px;
                  padding-bottom: 6px;
                  border-bottom: 1px dashed #E1E9EE;
                "
              >
                <span>${t('สถานีติดตาม')}</span>
                <span style="font-size: 14px; font-weight: 600; color: #1D3145;">
                  ${detail?.telestation ?? '-'}
                </span>
              </div>
            </div>
            
          </div>
        `;

        layer.bindPopup(popupClickContent, {
          className: 'ffpi-popup',
        });
        layer.on('click', () => layer.openPopup());
      }
    });
  }

  // set marker icon based on criteria
  setIcon = (val, type) => {
    const status = RainfallStatusColor(val, type);

    return status.icon;
  }

  getRiskAreaStyle = datas => feature => {
    const arrayRiskArea = datas;
    if (arrayRiskArea.indexOf(feature.properties.TAMBON_IDN) !== -1) {
      return {
        fillColor: '#c70000',
        weight: 3,
        opacity: 1,
        color: '#ff0000',
        fillOpacity: 0.7,
      };
    }

    return {
      stroke: false,
      fillColor: '#FFF',
      fillOpacity: 0,
    };
  }

  handleMouseOut() {
    this.setState({ hover: false });
  }

  getGeoJson() {
    // Promise.all([
    //   fetch('json/river/river_main.json'),
    //   fetch('json/boundary/tambon.json'),
    // ])
    //   .then(([res1, res2]) => Promise.all([res1.json(), res2.json()]))
    //   .then(([river, tambon]) => {
    //     this.setState({ geojsonRiver: river, geojsonTambon: tambon });
    //   })
    //   .catch(error => this.setState({ error }));

    Promise.all([
      fetch('json/boundary/tambon.json'),
    ])
      .then(([res1]) => Promise.all([res1.json()]))
      .then(([tambon]) => {
        this.setState({ geojsonTambon: tambon });
      })
      .catch(error => this.setState({ error }));
  }

  // get dam status
  rainfallStatus = (data, type) => {
    const status = RainfallStatusColor(parseFloat(data).toFixed(2), type);
    return status;
  }

  getRiverStyle = () => ({
    weight: 0.8,
    opacity: 1,
    color: '#007DBF',
  })

  getBasinStyle = () => ({
    stroke: true,
    color: '#434348',
    weight: 1,
    fillColor: '#b1b1f7',
    opacity: 1,
    fillOpacity: 0.3,
  })

  // add marker reference
  bindMarker = id => ref => {
    const { markers } = this.props;
    if (ref) {
      markers[id] = ref.leafletElement;
      markers[id].addEventListener('click', e => {
        this.map.panTo(e.target.getLatLng());
      });
    }
  }

  handleDatasFFPIReport = (datas, header) => {
    const {
      handleModalOpen,
    } = this.props;

    const params = {
    header: (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
        <p style={{ margin: 0 }}>ตารางพื้นที่เฝ้าระวัง</p>
      </div>
    ),
      content: <FlashFloodList
        datas={datas}
        header={header}
        onRowClick={this.handleFlyToTambon} 
      />,
    };
    handleModalOpen(params);
  }

  handleRainfallChart = (handler, data, type, filterData) => e => {
    const { t } = this.props;
    e.preventDefault();
    const params = {
      header: `${t('กราฟฝน')} ${data.station.tele_station_name.th}`,
      content: <FlashFloodChart
        id={data.station.id}
        provinceId={data.geocode.province_code}
        selectedType={type}
        filterData={filterData}
        year={(data.rainfall_datetime).substring(0, 4)}
        month={(data.rainfall_datetime).substring(5, 7)}
      />,
    };
    handler(params);
  }

  eachData = (data, i) => {
    console.log('lat:', data.lat, 'lng:', data.lng)
    const {
      classes, datasRainToday,
      handleModalOpen, t,
    } = this.props;

    if (data.station.tele_station_lat && data.station.tele_station_long
      && data.rainfall_value != null) {
      // marker position
      const position = [parseFloat(data.station.tele_station_lat),
      parseFloat(data.station.tele_station_long)];
      // marker icons
      const icon = this.setIcon(parseFloat(data.rainfall_value), 'rainfallToday');
      // status colors
      const rainfall = parseFloat(data.rainfall_value).toFixed(0);
      const textRainfallStatus = this.rainfallStatus(rainfall, 'rainfallToday').color.statusColor;
      const rainfallStatusFontColor = this.rainfallStatus(rainfall, 'rainfallToday').color.constrastColor;

      return (
        <Marker
          id={data.id}
          key={i}
          zIndexOffset={i}
          position={position}
          icon={icon}
          ref={this.bindMarker(data.id)}
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...this.props}
        >
          <Popup autoPan={false}>
            <Table className={classes.table}>
              <TableBody>
                <TableRow>
                  <TableCell className={classes.hiddenLine} padding="none" align="center" colSpan={2}>
                    <Typography variant="subtitle2" style={{ fontWeight: 600 }}>
                      {`${tJson(data.station.tele_station_name, ' ')}`}
                    </Typography>
                    <Typography variant="subtitle2" style={{ fontWeight: 600 }}>
                      {` ${tJson(data.geocode.amphoe_name, 'อ.')}`}
                      {` ${tJson(data.geocode.province_name, 'จ.')}`}
                    </Typography>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className={classes.hiddenLine} align="center" colSpan={2}>
                    <Box pt={1} display="flex" justifyContent="center" alignItems="center" width="100%">
                      <Box display="flex" width="50%">
                        <Box width="50%">
                          <Typography
                            variant="h6"
                            style={{
                              color: textRainfallStatus,
                              fontSize: '2em',
                            }}
                          >
                            <HiiRainIcon style={{ fontSize: 60 }} />
                          </Typography>
                        </Box>
                        <Box mt={1} width="50%">
                          <Typography
                            variant="h6"
                            style={{
                              backgroundColor: textRainfallStatus,
                              color: rainfallStatusFontColor,
                              fontSize: 16,
                              borderRadius: 3,
                            }}
                          >
                            {`${data.rainfall_value}`}
                          </Typography>
                          <Typography variant="h6">
                            {t('มม.')}
                          </Typography>
                        </Box>
                      </Box>
                    </Box>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className={classes.hiddenLine} padding="none" align="center" colSpan={2}>
                    <Typography variant="h6">
                      {t('ปริมาณฝนสะสมรายวัน')}
                    </Typography>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className={classes.hiddenLine} padding="none" align="center" colSpan={2}>
                    <Typography variant="caption" color="secondary">
                      {`${t('ข้อมูล')}: ${tJson(data.agency.agency_name, ' ')}`}
                    </Typography>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className={classes.hiddenLine}><Typography variant="caption" color="secondary">{`${data.rainfall_datetime} ${t('น.')}`}</Typography></TableCell>
                  <TableCell className={classes.hiddenLine} align="right">
                    <Button
                      color="secondary"
                      onClick={this.handleRainfallChart(handleModalOpen, data, 'rainfallYesterday', datasRainToday)}
                      title={t('แสดงกราฟ')}
                      style={{ padding: 0 }}
                    >
                      <FaChartLine className={classes.rightIcon} />
                    </Button>
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </Popup>
          <Hidden smDown>
            <Tooltip title={`${tJson(data.station.tele_station_name, 'สถานี')}`}>
              <span>
                <strong>
                  {`${tJson(data.station.tele_station_name, 'สถานี')}`}
                </strong>
                <br />
                {`${tJson(data.geocode.tumbon_name, 'ต.')} ${tJson(data.geocode.amphoe_name, 'อ.')} ${tJson(data.geocode.province_name, 'จ.')}`}
                <br />
                {`${t('ข้อมูล')}:${tJson(data.agency.agency_name, ' ')}`}
              </span>
            </Tooltip>
          </Hidden>
        </Marker>
      );
    }
    return false;
  }

  highlightFeature = e => {
    const layer = e.target;
    layer.setStyle({
      fillOpacity: 0.6,
      stroke: true,
      color: '#434348',
    });
    if (!L.Browser.ie && !L.Browser.opera && !L.Browser.edge) {
      layer.bringToFront();
    }
    layer.bindTooltip(`<h4>${layer.feature.properties.BASIN_T}</h4>`).openTooltip();
  }

  resetHighlight = e => {
    this.refBoundaryBasin.current.leafletElement.resetStyle(e.target);
  }

  onEachBasinFeature = (feature, layer) => {
    layer.on({
      mouseover: this.highlightFeature,
      mouseout: this.resetHighlight,
    });
  }

  handleBoxToggle = () => this.setState({ hover: true });

  handleSetURL = event => {
    const val = event.target.value;
    // this.setState({ tifValue: val });
    this.refCompRadar.current.leafletElement.setURL(`${process.env.REACT_APP_FEWS_URL}/model-output/data_portal/flashflood/${val}`);
  }

  handleClickLegendRisk = () => {
    const { openLegendRisk } = this.state;
    if (openLegendRisk === false) {
      this.setState({ openLegendRisk: true });
    } else {
      this.setState({ openLegendRisk: false });
    }
  };

  handleClickLegendFFPI = () => {
    const { openLegendFFPI } = this.state;
    if (openLegendFFPI === false) {
      this.setState({ openLegendFFPI: true });
    } else {
      this.setState({ openLegendFFPI: false });
    }
  };

  handleClickLegendFcstRain = () => {
    const { openLegendFcstRain } = this.state;
    if (openLegendFcstRain === false) {
      this.setState({ openLegendFcstRain: true });
    } else {
      this.setState({ openLegendFcstRain: false });
    }
  };

  handleClickLegendObsRain = () => {
    const { openLegendObsRain } = this.state;
    if (openLegendObsRain === false) {
      this.setState({ openLegendObsRain: true });
    } else {
      this.setState({ openLegendObsRain: false });
    }
  };

  handleClickLegendRainfall = () => {
    const { openLegendRainfall } = this.state;
    if (openLegendRainfall === false) {
      this.setState({ openLegendRainfall: true });
    } else {
      this.setState({ openLegendRainfall: false });
    }
  };

  handleClickLegendFcstRain = () => {
    const { openLegendFcstRain } = this.state;

    if (openLegendFcstRain === false) {
      this.setState({ openLegendFcstRain: true });
    } else {
      this.setState({ openLegendFcstRain: false });
    }
  };

  handleClickLegendObsRain = () => {
    const { openLegendObsRain } = this.state;

    if (openLegendObsRain === false) {
      this.setState({ openLegendObsRain: true });
    } else {
      this.setState({ openLegendObsRain: false });
    }
  };

  handleClickLegendRisk = () => {
    const { openLegendRisk } = this.state;

    if (openLegendRisk === false) {
      this.setState({ openLegendRisk: true });
    } else {
      this.setState({ openLegendRisk: false });
    }
  };

  toggleBox = () => {
    const { isBoxVisible } = this.state;
    this.setState({ isBoxVisible: isBoxVisible === false });

    const layers = document.getElementsByClassName('leaflet-control-layers-expanded');
    if (isBoxVisible === true) {
      for (let index = 0; index < layers.length; index++) {
        document.getElementsByClassName('leaflet-control-layers-expanded')[index].style.display = 'none';
      }
    } else {
      for (let index = 0; index < layers.length; index++) {
        document.getElementsByClassName('leaflet-control-layers-expanded')[index].style.display = 'block';
      }
    }
  };

  handleClickBoxDetail = () => {
    const { openBoxDetail } = this.state;
    if (openBoxDetail === false) {
      this.setState({ openBoxDetail: true });
    } else {
      this.setState({ openBoxDetail: false });
    }
  };

  handleFlyToTambon = (row) => {
    const { handleModalClose } = this.props;
    const { geojsonTambon } = this.state;
    const features = geojsonTambon?.features || [];

    const feature = features.find(f => row.tambonId && String(f.properties.TAMBON_IDN) === String(row.tambonId))
      || features.find(f =>
        f.properties.TAM_NAM_T?.includes(row.tumbon) &&
        f.properties.AMPHOE_T?.includes(row.amphon)
      );

    if (!feature || !this.map) return;

    if (handleModalClose) handleModalClose();

    const bounds = L.geoJSON(feature).getBounds();
    this.map.flyToBounds(bounds, { maxZoom: 13, duration: 1 });
  };

  getRainfallData = () => {
    const {
      rainfallType,
      dataRainfall24,
      datasRainTodayMarker,
      datasRainYesterday,
      datasRain3day,
      datasRain7day,
      datasRain15Day,
      datasRain30Day,
    } = this.props;

    switch (rainfallType) {
      case 'rainfallYesterday': return datasRainYesterday;
      case 'rainfallToday':     return datasRainTodayMarker;
      case 'rainfall24h':       return dataRainfall24;
      case 'rainfall3day':      return datasRain3day;
      case 'rainfall7day':      return datasRain7day;
      case 'rainfall15day':     return datasRain15Day;
      case 'rainfall30day':     return datasRain30Day;
      default: return [];
    }
  };

  PopupRainfall = (data, value, stationName, provinceName) => {
    const { t, rainfallType } = this.props;
    const { classes } = this.props;

    const status = RainfallStatusColor(parseFloat(value), rainfallType);
    const rainfallStatus = status.color.statusColor;
    const textRainfallStatus = status.color.constrastColor;

    const amphoeName = data.geocode?.amphoe_name?.th ?? data.amphoe_name?.th ?? '';
    const tumbonName = data.geocode?.tumbon_name?.th ?? data.tumbon_name?.th ?? '';
    const agencyName = data.agency?.agency_name?.th ?? data.agency_name?.th ?? '';
    const datetime = data.rainfall_datetime ?? data.rainfall_end_date ?? '';
    const oldCode = data.station?.tele_station_oldcode ?? data.tele_station_oldcode ?? '';

    return (
      <TableContainer style={{ minWidth: 280 }}>
        <Table size="small">
          <TableHead />
          <TableBody>
            <TableRow>
              <TableCell className={classes.hiddenLine} padding="none" align="center" colSpan={3}>
                <Box fontWeight="500" fontFamily="Kanit" fontSize="14px">
                  {oldCode ? `${oldCode} ${stationName}` : stationName}
                </Box>
                <Box fontFamily="Kanit" fontSize="12px">
                  {`ต.${tumbonName} อ.${amphoeName} จ.${provinceName}`}
                </Box>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.hiddenLine} padding="none" align="center" colSpan={3}>
                <Box py={3} display="flex" justifyContent="center" alignItems="center">
                  <RainIcon
                    style={{
                      fontSize: '4rem',
                      fill: rainfallStatus,
                      stroke: rainfallStatus === '#ffffff' ? '#000' : undefined,
                    }}
                  />
                  <Box>
                    <Box
                      p={1}
                      className={classes.statusText}
                      fontFamily="Kanit"
                      bgcolor={rainfallStatus}
                      color={textRainfallStatus}
                      border={rainfallStatus === '#ffffff' ? 1 : undefined}
                    >
                      {formatNumber(value)}
                    </Box>
                    <Box fontFamily="Kanit" fontSize={12}>({t('มม.')})</Box>
                  </Box>
                </Box>
                <Box mb={2} fontSize="16px" fontFamily="Kanit">
                  {t('ปริมาณฝน')}
                </Box>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.hiddenLine} colSpan={3}>
                <Box color="text.disabled" fontSize="8px">
                  {`${t('ข้อมูล')}: ${agencyName}`}
                </Box>
                <Box color="text.disabled" fontSize="8px">
                  {`${t('ล่าสุด')} : ${datetime}`}
                </Box>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    );
  };

  eachRainfallMarker = (data, i) => {
    const { rainfallType, t } = this.props;

    const lat = data.station?.tele_station_lat ?? data.tele_station_lat;
    const lng = data.station?.tele_station_long ?? data.tele_station_long;
    if (!lat || !lng) return null;

    let value = null;
    if (rainfallType === 'rainfall24h')       value = data.rain_24h;
    if (rainfallType === 'rainfallToday')     value = data.rainfall_value;
    if (rainfallType === 'rainfallYesterday') value = data.rainfall_value;
    if (rainfallType === 'rainfall3day')      value = data.rain_3d;
    if (rainfallType === 'rainfall7day')      value = data.rain_7d;
    if (rainfallType === 'rainfall15day')     value = data.rain_15d;
    if (rainfallType === 'rainfall30day')     value = data.rainfall_value;
    if (value === null || value === undefined) return null;

    const status = RainfallStatusColor(parseFloat(value), rainfallType);
    if (!status || !status.icon) return null;

    const position = [parseFloat(lat), parseFloat(lng)];
    const stationName = data.station?.tele_station_name?.th ?? data.tele_station_name?.th ?? '';
    const provinceName = data.geocode?.province_name?.th ?? data.province_name?.th ?? '';
    const amphoeName = data.geocode?.amphoe_name?.th ?? data.amphoe_name?.th ?? '';
    const tumbonName = data.geocode?.tumbon_name?.th ?? data.tumbon_name?.th ?? '';
    const oldCode = data.station?.tele_station_oldcode ?? data.tele_station_oldcode ?? '';

    return (
      <Marker key={`rainfall-${i}`} position={position} icon={status.icon}>
        <Tooltip>
          <span>
            <strong>{oldCode ? `${oldCode} ${stationName}` : stationName}</strong><br />
            {`ต.${tumbonName} อ.${amphoeName} จ.${provinceName}`}<br />
            {`${t('ปริมาณฝน')} `}<strong>{value}</strong>{` ${t('มม.')}`}
          </span>
        </Tooltip>
        <Popup autoPan={false}>
          {this.PopupRainfall(data, value, stationName, provinceName)}
        </Popup>
      </Marker>
    );
  };
  
  render() {
    const {
      error, geojsonTambon, openLegendRisk, openLegendFcstRain, openLegendFFPI, showInfo,
      openLegendObsRain, openLegendRainfall, hover, isBoxVisible, initActive, isBoxDetail, openBoxDetail,
    } = this.state;
    const {
      location, zoom, datas, header, datasRainToday, arrayTambonId, arrayTambonIdNhc, datasNhc, dataStorm, t, width, showMainRiver
      , showSecoundRiver, showProvinceBoundary, showAmphoeBoundary, showTambonBoundary, rainfallEnabled, rainfallType, sidebarOpen, onOpenSidebar, riverEnabled, forecastRainEnabled, forecastRainDay, ffpiEnabled, forecastRainUrl, datasRain30Day , forecastAccumUrl, obsRainUrl
    } = this.props;

    let errorMsg = '';
    if (error) {
      errorMsg = (
        <div className="text-center">{error.message}</div>
      );
    }
    // const wrfUrlObsRain = `${process.env.MIX_FEWS_URL}/model-output/data_portal/flashflood/obs_rain.tif`; //ObsRain old version
    const wrfUrlObsRain = `${process.env.REACT_APP_MIX_HYDRO_URL}tiffile/obs/obs_rain_4326.tiff`; //ObsRain new version
    const wrfUrlFcstRain = `${process.env.REACT_APP_MIX_HYDRO_URL}tiffile/fcst/fcst_rain_4326.tiff`;

    const layers = document.getElementsByClassName('leaflet-control-layers-expanded');
    if (isWidthDown('sm', width) && initActive === false) {
      for (let index = 0; index < layers.length; index++) {
        document.getElementsByClassName('leaflet-control-layers-expanded')[index].style.display = 'none';
        if(index > 2 ){
        this.setState({ initActive: true, isBoxVisible: false });
        }
      }
    }

    const tooltipStyle = {
      display: hover ? 'block' : 'none',
      maxWidth: '337px',
      padding: '10px',
      wordBreak: 'break-word',
    };

    const { classes } = this.props;
    return (
      <>
        {errorMsg}

        <Map
          id="map"
          center={location}
          zoom={zoom}
          ref={this.refMap}
          style={{
            height: '100%',
            width: '100%',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 1300,
          }}
        >
          {showMainRiver && (
            <WMSTileLayer
              url={`${initPathWMS3}`}
              version="1.1.0"
              opacity={1}
              transparent={true}
              layers="spm:stream_main_84utf8"
              format="image/png"
              zIndex={200}
              styles=""
            />
          )}

          {showSecoundRiver && (
            <WMSTileLayer
              url={`${initPathWMS3}`}
              version="1.1.0"
              opacity={1}
              transparent
              layers="spm:stream_2_84utf8"
              format="image/png"
              zIndex={200}
            />
          )}

          {showProvinceBoundary && (
            <WMSTileLayer
              url={`${initPathWMS1}/wms`}
              version="1.1.1"
              opacity={1}
              transparent
              layers="boundary_province_dopa"
              format="image/png"
              styles="boundary_province_no_zoom"
              zIndex={200}
            />
          )}

          {showAmphoeBoundary && (
            <WMSTileLayer
              url={`${initPathWMS1}/wms`}
              version="1.1.1"
              opacity={1}
              transparent
              layers="boundary_amphoe_dopa"
              format="image/png"
              styles="boundary_amphoe_no_zoom"
              zIndex={200}
            />
          )}

          {showTambonBoundary && (
            <WMSTileLayer
              url={`${initPathWMS1}/wms`}
              version="1.1.1"
              opacity={1}
              transparent
              layers="boundary_tambon_dopa"
              format="image/png"
              styles="boundary_tambon_no_zoom"
              zIndex={200}
            />
          )}

          {rainfallEnabled && rainfallType && (
            <LayerGroup>
              {this.getRainfallData().map(this.eachRainfallMarker)}
            </LayerGroup>
          )}

          {this.props.stormEnabled && (
            <StormTwcLayer
              layerRef={this.refStrom}
              datas={dataStorm}
            />
          )}

          {this.props.riskAreaEnabled && (
            <LayerGroup ref={this.layer}>
              <GeoJSON
                key={JSON.stringify(arrayTambonIdNhc)}
                data={geojsonTambon}
                style={this.getRiskAreaStyle(arrayTambonIdNhc)}
                onEachFeature={this.onEachRiskAreaFeatureNhc}
              />
            </LayerGroup>
          )}

          {riverEnabled && (
            <WMSTileLayer
              url={`${initPathWMS1}thaiwater30/wms`}
              version="1.1.0"
              opacity={1}
              transparent
              layers="thaiwater30:river_thailand"
              srs="EPSG:4326"
              format="image/png"
              tiled
              zIndex={200}
            />
          )}

          {forecastRainEnabled && (
            <PlottyGeotiffLayer
              key={`fcst-rain-day-${forecastRainDay}`}
              layerRef={this.refGeotiff1}
              layerMap={this.refMap}
              url={forecastRainUrl}  //${process.env.REACT_APP_MIX_HYDRO_URL}tiffile/fcst/${date}_day${day}.tif example : ${process.env.REACT_APP_MIX_HYDRO_URL}tiffile/fcst/20260819_1.tif (current Date 20260819)
              options={fcstRainOptions}
              name=""
            />
          )}

          {forecastAccumUrl && (
            <PlottyGeotiffLayer
              key={`accum-rain-${forecastAccumUrl}`}
              layerRef={this.refGeotiff2}
              layerMap={this.refMap}
              url={forecastAccumUrl} //${process.env.REACT_APP_MIX_HYDRO_URL}tiffile/wrfroms/${days}/wrfroms_${dateStr}1200.tif
              options={fcstRainOptions}
              name=""
            />
          )}

          {ffpiEnabled && (
            <FFPIGeotiffLayer
              key="ffpi-layer"
              layerRef={this.refFfpi}
              layerMap={this.refMap}
              url={`${process.env.REACT_APP_MIX_HYDRO_URL}/tiffile/FFPI/FFPI_Index_4326.tiff`}
              options={ffpiOptions}
              name="FFPI"
            />
          )}

          {obsRainUrl && (
            <PlottyGeotiffLayer
              key={`obs-rain-${obsRainUrl}`}
              layerRef={this.refObsRain}
              layerMap={this.refMap}
              url={obsRainUrl} // ${process.env.REACT_APP_MIX_HYDRO_URL}tiffile/obs/obs_rain_4326.tif
              options={obsRainOptions}
              name=""
            />
          )}

          <Control position="topleft">
            <button
              onClick={onOpenSidebar}
              style={{
                width: 36,
                height: 36,
                padding: 6,
                borderRadius: 8,
                border: '1px solid #F6F6F6',
                background: '#FFFFFF',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer',
                outline: 'none',
                visibility: sidebarOpen ? 'hidden' : 'visible',
                pointerEvents: sidebarOpen ? 'none' : 'auto',
              }}
            >
              <MenuIcon style={{ fontSize: 24, color: '#000000' }} />
            </button>
          </Control>

          <FullscreenControl position="topleft" />
          <CurrentLocation mapRef={this.refMap} showOnly={false} />

          <LayersControl position="topright">
            <BaseLayer name="OSM (default)" checked>
              <TileLayer
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                id="OpenStreetMap.Mapnik"
                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
              />
            </BaseLayer>
            <BaseLayer name="ESRI">
              <TileLayer
                url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}"
                attribution="Tiles &copy; Esri &mdash; Source: Esri, DeLorme, NAVTEQ, USGS, Intermap, iPC, NRCAN, Esri Japan, METI, Esri China (Hong Kong), Esri (Thailand), TomTom, 2012"
              />
            </BaseLayer>
            <BaseLayer name="Satellite">
              <TileLayer
                url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}"
                attribution="Tiles &copy; Esri &mdash; Source: Esri, Maxar, Earthstar Geographics, and the GIS User Community"
              />
            </BaseLayer>
            <BaseLayer name="Light">
              <TileLayer
                url="https://{s}.tile.openstreetmap.fr/hot/{z}/{x}/{y}.png"
                attribution='&copy; OpenStreetMap contributors'
              />
            </BaseLayer>
            <BaseLayer name="Stadia">
              <TileLayer
                url={`https://{s}.tile.jawg.io/jawg-dark/{z}/{x}/{y}{r}.png?access-token=${jawgToken}`}
                attribution='&copy; <a href="https://www.jawg.io">Jawg Maps</a> &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
              />
            </BaseLayer>
            {/* <BaseLayer name="Carto">
              <TileLayer
                url="https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png"
                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>'
              />
            </BaseLayer> */}
            {/* <Overlay name={t('เส้นแม่น้ำ')} checked>
              <WMSTileLayer
                url={`${initPathWMS1}thaiwater30/wms`}
                version="1.1.0"
                opacity={1}
                transparent
                layers="layers=thaiwater30:river_thailand"
                srs="EPSG:4326"
                format="image/png"
                tiled
              />
            </Overlay> */}
          </LayersControl>

          {/* <Control position="topleft">
            <Hidden mdUp>
              <Button
                onClick={this.toggleBox}
                style={{
                  display: 'flex',
                  backgroundColor: 'white',
                  zIndex: 99999,
                  marginBottom: 10,
                  marginTop: 5,
                  fontFamily: 'Kanit',
                  fontWeight: 400,
                }}
              >
                {t('ชั้นข้อมูล')}
                {isBoxVisible ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
              </Button>
            </Hidden>
            <PlottyGeotiffLayer
              layerRef={this.refGeotiff1}
              layerMap={this.refMap}
              url={wrfUrlFcstRain}
              options={fcstRainOptions}
              name="Acc. Fcst. Rain 1 Day"
            />
            <PlottyGeotiffLayer
              layerRef={this.refGeotiff2}
              url={wrfUrlObsRain}
              options={obsRainOptions}
              name="Acc. Obs. Rain 5 Day"
            />
            <LayersControl position="topleft" collapsed={false}>
              <Overlay key="floodForecast1" name="Telemetering Station">
                <LayerGroup ref={this.layer}>
                  {datasRainToday.map(this.eachData)}
                </LayerGroup>
              </Overlay>
            </LayersControl>
          </Control> */}

          <Control position="topleft">
            <div style={{ display: "flex", flexDirection: "row", alignItems: "flex-start" }}>
            <div
              style={{
                backgroundColor: "white",
                padding: "5px",
                borderRadius: "2px",
                width: "30px",
                height: "30px",
                marginLeft:"2px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
              }}
              onClick={() => this.setState(prev => ({ showInfo: !prev.showInfo }))}
            >
              <InfoOutlinedIcon style={{ color: '#000000' }} />
            </div>
          {showInfo && (
            <Paper elevation={3} style={{ borderRadius: "11px", overflow: "hidden", marginLeft: "5px" }}>
              <div style={{ maxWidth: "500px", fontFamily: "Kanit" }}>
                <div style={{
                  backgroundColor: "#ffffff",
                  padding: "10px 14px",
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}>
                  <InfoOutlinedIcon style={{ color: "#1C1B1F", fontSize: "20px", flexShrink: 0 }} />
                  <span style={{
                    fontFamily: "Kanit",
                    fontWeight: 700,
                    fontSize: "15px",
                    lineHeight: "1.3",
                    color: "#13263A",
                  }}>
                    {t("ระบบเตือนภัยน้ำท่วมฉับพลัน")}
                  </span>
                </div>

                {/* Content */}
                <div style={{
                  padding: "10px 14px",
                  fontFamily: "Kanit",
                  fontWeight: 400,
                  fontSize: "12px",
                  marginTop:"-15px",
                  color: "#000000",
                }}>
                  <p style={{ margin: "0 0 6px 0" }}>
                    {t("ระบบเตือนภัยน้ำท่วมฉับพลัน เป็นระบบที่ใช้ประเมินและคาดการณ์พื้นที่เสี่ยงน้ำท่วมฉับพลันภายใน 24 ชั่วโมงข้างหน้า โดยอาศัยเทคนิคการซ้อนทับข้อมูล 3 ประเภท ได้แก่")}
                  </p>
                  <p style={{ margin: "0 0 2px 0" }}>
                    {t("1. ดัชนีศักยภาพการเกิดน้ำท่วมฉับพลัน (FFPI Index)")}
                  </p>
                  <p style={{ margin: "0 0 2px 0" }}>
                    {t("2. สถานะระดับความชื้นสะสมในดิน (AMC Class)")}
                  </p>
                  <p style={{ margin: "0 0 6px 0" }}>
                    {t("3. ข้อมูลฝนคาดการณ์ (WRF-ROMS)")}
                  </p>
                  <p style={{ margin: 0 }}>
                    {t("ระบบปฏิบัติการประมวลผลอัตโนมัติทุกวัน เวลา 10.05 น. และ 16.05 น.   เพื่อระบุพื้นที่เสี่ยงในระดับตำบล พร้อมแสดงผลในรูปแบบแผนที่ ตาราง และกราฟสรุปสถานการณ์ ช่วยให้หน่วยงานที่เกี่ยวข้องและประชาชนสามารถเฝ้าระวังและเตรียมความพร้อมได้อย่างทันท่วงที")}
                  </p>
                </div>

                {/* Footer */}
                <div style={{
                  padding: "6px 14px 10px",
                  fontFamily: "Kanit",
                  fontWeight: 700,
                  fontSize: "12px",
                  color: "#13263A",
                }}>
                  {t("อ้างอิงเอกสารวิชาการ")}
                  <div style={{ fontWeight: 400, marginTop: "2px", display: "flex", flexDirection: "column", gap: "4px" }}>
                    <a href="https://iahrapd2020.xsrv.jp/proceedings/pdf/6-4-3.pdf" target="_blank" rel="noopener noreferrer" style={{ color: "#757575", fontSize: "8px" }}>
                      {t("[1] FLASH FLOOD PREDICTION USING HIGH RESOLUTION SATELLITE RAINFALL DATA IN THE SOUTHERN PART OF THAILAND")}
                    </a>
                    <a href="https://link.springer.com/chapter/10.1007/978-981-19-1600-7_28" target="_blank" rel="noopener noreferrer" style={{ color: "#757575", fontSize: "8px" }}>
                      {t("[2] Improving the Efficiency of Flash Flood Forecasting and Warning System in Thailand")}
                    </a>
                    <a href="https://www.hii.or.th/wp-content/uploads/2025/03/10-Improving-the-efficiency-of-Flash-Flood-Forecasting-and-Warning-System-in-Thailand.pdf" target="_blank" rel="noopener noreferrer" style={{ color: "#757575", fontSize: "8px" }}>
                      {t("[3] IMPROVING THE EFFICIENCY OF FLASH FLOOD FORECASTING AND WARNING SYSTEM IN THAILAND ")}
                    </a>
                  </div>
                </div>

              </div>
            </Paper>
          )}
          </div>
          </Control>
          {/* <img src={banner} alt="banner" className={classes.styleBanner} /> */}
          {/* <Control position="topright" style={{ marginTop: 30 }}> */}
            {/* <Box display="flex" justifyContent="flex-end">
              <Button
                variant="contained"
                position="right"
                style={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  backgroundColor: 'white',
                  zIndex: 99999,
                  // textTransform: 'none',
                  // marginTop: '40%',
                }}
                aria-haspopup="true"
                onClick={this.handleClickBoxDetail}
              >
                {t('รายละเอียด')}
                {openBoxDetail ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
              </Button>
            </Box> */}
            {/* {openBoxDetail ? (
              <> */}
                {/* <Box
                  style={{
                    backgroundColor: 'white', padding: '8px', borderRadius: '9px', marginBottom: 20, marginTop: '5px',
                  }}
                >
                  <strong>Flash Flood Risk Areas</strong>
                  <br />
                  {header[0]?.[0] ?? ''}
                  <br />
                  {header[1]?.[0] ?? ''}
                </Box>

                <Button
                  variant="contained"
                  style={{
                    backgroundColor: 'white',
                    zIndex: 99999,
                    textTransform: 'none',
                  }}
                  aria-haspopup="true"
                  onClick={() => this.handleDatasFFPIReport(datas, header)}
                  startIcon={<FormatListBulletedIcon />}
                >
                  Detail of Flash Flood Risk Area (GSMAP)
                </Button>
                <br />
                <br /> */}

                {/* <Button
                  variant="contained"
                  style={{
                    backgroundColor: 'white',
                    zIndex: 99999,
                    textTransform: 'none',
                  }}
                  aria-haspopup="true"
                  onClick={() => this.handleDatasFFPIReport(datasNhc, header)}
                  startIcon={<FormatListBulletedIcon />}
                >
                  Detail of Flash Flood Risk Areas
                </Button> */}
              {/* </>
            )
              : null} */}
          {/* </Control> */}
          <div style={{
            position: 'absolute',
            bottom: 16,
            left: 0,
            right: 0,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            pointerEvents: 'none',
            zIndex: 99999,
          }}>
            <Button
              variant="contained"
              style={{
                height: 40,
                borderRadius: 9,
                paddingRight: 14,
                paddingLeft: 14,
                backgroundColor: 'rgba(0, 0, 0, 0.44)',
                border: '1px solid rgba(255, 255, 255, 0.18)',
                boxShadow: 'none',
                textTransform: 'none',
                fontFamily: 'Kanit',
                fontWeight: 300,
                fontSize: 14,
                color: '#FFFFFF',
                lineHeight: 1,
                letterSpacing: 0,
                pointerEvents: 'auto',
              }}
              aria-haspopup="true"
              onClick={() => this.handleDatasFFPIReport(datasNhc, header)}
            >
              <span style={{ marginRight: 10, fontSize: 16 }}>▦</span>ตารางพื้นที่เสี่ยง
            </Button>
          </div>
          {ffpiEnabled && (
          <Control position="bottomright">
            {/* Legend */}
            {openLegendFFPI ? <LegendFFPI/> : null}
            <Button
              variant="contained"
                style={{
                  width: "152px",
                  height: "34px",
                  padding: "6px",
                  borderRadius: "4px",
                  border: "1px solid #BBCEDAE5",
                  backgroundColor: "#FFFFFF",
                  boxShadow: "none",
                  textTransform: "none",
                  fontFamily: "Kanit",
                  fontWeight: 400,
                  fontSize: "14px",
                  lineHeight: "18px",
                  letterSpacing: "0px",
                  textAlign: "center",
                  zIndex: 99999,
                }}
              aria-haspopup="true"
              onClick={this.handleClickLegendFFPI}
              endIcon={
                openLegendFFPI
                  ? <KeyboardArrowUpIcon />
                  : <KeyboardArrowDownIcon />
              }
            >
              FFPI
            </Button>
          </Control>
          )}
          {/* <Control position="bottomright">
            Legend
            {openLegendRisk ? <LegendRisk /> : null}
            <Button
              variant="contained"
                style={{
                  width: "152px",
                  height: "34px",
                  padding: "6px",
                  borderRadius: "4px",
                  border: "1px solid #BBCEDAE5",
                  backgroundColor: "#FFFFFF",
                  boxShadow: "none",
                  textTransform: "none",
                  fontFamily: "Kanit",
                  fontWeight: 400,
                  fontSize: "14px",
                  lineHeight: "18px",
                  letterSpacing: "0px",
                  textAlign: "center",
                  zIndex: 99999,
                }}
              aria-haspopup="true"
              onClick={this.handleClickLegendRisk}
              endIcon={
                openLegendRisk
                  ? <KeyboardArrowUpIcon />
                  : <KeyboardArrowDownIcon />
              }
            >
              พื้นที่เสี่ยง
            </Button>
          </Control> */}
          {(forecastRainEnabled || forecastAccumUrl) &&(
          <Control position="bottomright">
            {openLegendFcstRain ? <LegendFcstRain /> : null}
            <Button
              variant="contained"
                style={{
                  width: "152px",
                  height: "34px",
                  padding: "6px",
                  borderRadius: "4px",
                  border: "1px solid #BBCEDAE5",
                  backgroundColor: "#FFFFFF",
                  boxShadow: "none",
                  textTransform: "none",
                  fontFamily: "Kanit",
                  fontWeight: 400,
                  fontSize: "14px",
                  lineHeight: "18px",
                  letterSpacing: "0px",
                  textAlign: "center",
                  zIndex: 99999,
                }}
              aria-haspopup="true"
              onClick={this.handleClickLegendFcstRain}
              endIcon={
                openLegendFcstRain
                  ? <KeyboardArrowUpIcon />
                  : <KeyboardArrowDownIcon />
              }
            >
              คาดการณ์ฝน (มม.)
            </Button>
          </Control>
          )}
          {rainfallEnabled && (
          <Control position="bottomright">
            {openLegendObsRain ? <LegendObsRain rainfallType={rainfallType} /> : null}
            <Button
              variant="contained"
                style={{
                  minWidth: "152px",
                  height: "34px",
                  padding: "6px",
                  borderRadius: "4px",
                  border: "1px solid #BBCEDAE5",
                  backgroundColor: "#FFFFFF",
                  boxShadow: "none",
                  textTransform: "none",
                  fontFamily: "Kanit",
                  fontWeight: 400,
                  fontSize: "14px",
                  lineHeight: "18px",
                  letterSpacing: "0px",
                  textAlign: "center",
                  zIndex: 99999,
                }}
              aria-haspopup="true"
              onClick={this.handleClickLegendObsRain}
              endIcon={
                openLegendObsRain
                  ? <KeyboardArrowUpIcon />
                  : <KeyboardArrowDownIcon />
              }
            >
              {RAINFALL_LEGEND_TITLE[rainfallType] || 'เกณฑ์ฝนตรวจวัด (มม.)'}
            </Button>
          </Control>
          )}

          {obsRainUrl && (
          <Control position="bottomright">
            {openLegendObsRain ? <LegendObsRain5day /> : null}
            <Button
              variant="contained"
                style={{
                  width: "152px",
                  height: "34px",
                  padding: "6px",
                  borderRadius: "4px",
                  border: "1px solid #BBCEDAE5",
                  backgroundColor: "#FFFFFF",
                  boxShadow: "none",
                  textTransform: "none",
                  fontFamily: "Kanit",
                  fontWeight: 400,
                  fontSize: "14px",
                  lineHeight: "18px",
                  letterSpacing: "0px",
                  textAlign: "center",
                  zIndex: 99999,
                }}
              aria-haspopup="true"
              onClick={this.handleClickLegendObsRain}
              endIcon={
                openLegendObsRain
                  ? <KeyboardArrowUpIcon />
                  : <KeyboardArrowDownIcon />
              }
            >
              ฝนสะสม 5 วัน (มม.)
            </Button>
          </Control>
          )}
          {/* <Control position="bottomright">
            {openLegendRainfall ? <LegendRainfall /> : null}
            <Button
              variant="contained"
                style={{
                  width: "152px",
                  height: "34px",
                  padding: "6px",
                  borderRadius: "4px",
                  border: "1px solid #BBCEDAE5",
                  backgroundColor: "#FFFFFF",
                  boxShadow: "none",
                  textTransform: "none",
                  fontFamily: "Kanit",
                  fontWeight: 400,
                  fontSize: "14px",
                  lineHeight: "18px",
                  letterSpacing: "0px",
                  textAlign: "center",
                  zIndex: 99999,
                }}
              aria-haspopup="true"
              onClick={this.handleClickLegendRainfall}
              endIcon={
                openLegendRainfall
                  ? <KeyboardArrowUpIcon />
                  : <KeyboardArrowDownIcon />
              }
            >
              ฝนสะสม (มม.)
            </Button>
          </Control> */}
        </Map>
      </>
    );
  }
}

FlashFloodMap.propTypes = {
  classes: PropTypes.object.isRequired,
  datas: PropTypes.array.isRequired,
  datasRiskArea: PropTypes.array.isRequired,
  datasNhc: PropTypes.array.isRequired,
  datasRiskAreaNhc: PropTypes.array.isRequired,
  dataStorm: PropTypes.array.isRequired,
  arrayTambonId: PropTypes.array.isRequired,
  arrayTambonIdNhc: PropTypes.array.isRequired,
  markers: PropTypes.array.isRequired,
  location: PropTypes.array.isRequired,
  zoom: PropTypes.number.isRequired,
  handleSetMap: PropTypes.func.isRequired,
  handleModalOpen: PropTypes.func.isRequired,
  width: PropTypes.oneOf(['lg', 'md', 'sm', 'xl', 'xs']).isRequired,
  header: PropTypes.array.isRequired,
  datasRainToday: PropTypes.array.isRequired,
  t: PropTypes.func.isRequired,
  showMainRiver: PropTypes.bool,
  showSecoundRiver: PropTypes.bool,
  showProvinceBoundary: PropTypes.bool,
  showAmphoeBoundary: PropTypes.bool,
  rainfallEnabled: PropTypes.bool,
  rainfallType: PropTypes.string,
  dataRainfall24: PropTypes.array,
  datasRainTodayMarker: PropTypes.array,
  datasRainYesterday: PropTypes.array,
  datasRain3day: PropTypes.array,
  datasRain7day: PropTypes.array,
  datasRain15Day: PropTypes.array,
  stormEnabled: PropTypes.bool,
  riskAreaEnabled: PropTypes.bool,
  sidebarOpen: PropTypes.bool.isRequired,
  onOpenSidebar: PropTypes.func.isRequired,
  riverEnabled: PropTypes.bool.isRequired,
  forecastRainEnabled: PropTypes.bool,
  forecastRainDay: PropTypes.number,
  ffpiEnabled: PropTypes.bool,
  forecastRainUrl: PropTypes.string,
  datasRain30Day: PropTypes.array.isRequired,
  forecastAccumUrl: PropTypes.string,
  handleModalClose: PropTypes.func,
  obsRainUrl: PropTypes.string,
};

export default compose(withWidth(), withStyles(styles), withTranslation())(FlashFloodMap);
